import React, { Component, ReactNode } from "react";
import classnames from "classnames";
import { observer } from "mobx-react";

import { Fader } from "@formant/ui/component/common/Fader";
import { IconName } from "@formant/ui/component/common/Icon";

import { appStore } from "../../stores";
import * as styles from "./SidebarTabs.scss";
import { SidebarTabsButton } from "./SidebarTabsButton";

export interface ISidebarTab {
    name: string;
    content: ReactNode;
    enabled: boolean;
    icon?: IconName;
}

export interface ISidebarTabsProps {
    tabs: ISidebarTab[];
    onClose: () => void;
}

@observer
export class SidebarTabs extends Component<ISidebarTabsProps> {
    public render() {
        const { onClose, tabs: unfilteredTabs } = this.props;
        const tabs = unfilteredTabs.filter(tab => {
            return tab.enabled;
        });

        return (
            <div className={styles["sidebar-tabs"]}>
                {tabs.length > 1 && (
                    <div className={styles["button-container"]}>
                        {tabs.map(({ name, icon }, i) => (
                            <SidebarTabsButton
                                key={i}
                                index={i}
                                name={name}
                                icon={icon}
                                active={i === appStore.sidebarActiveTabIndex}
                                onActivateTab={this.onActivateTab}
                            />
                        ))}
                    </div>
                )}

                <div className={styles["tab-container"]}>
                    {tabs.map((tab, i) => {
                        const active = i === appStore.sidebarActiveTabIndex;
                        return (
                            <Fader
                                key={i}
                                visible={active}
                                className={classnames(
                                    styles.tab,
                                    active && styles.active,
                                )}
                                onClick={onClose}
                            >
                                {tab.content}
                            </Fader>
                        );
                    })}
                </div>
            </div>
        );
    }

    private onActivateTab = (i: number) => {
        appStore.sidebarActiveTabIndex = i;
    };
}
